export default __webpack_public_path__ + "static/media/vendingmachine.28c5aa4e.jpg";